import notifierMixin from '@/mixins/notifierMixin';
import { DISCOUNT_IN_KOPECK } from '@/components/SwitchDiscountType.vue';

/**
 * @description Примесь счетов.
 * @type {any}
 */
export default {
  computed: {
    /**
     * @description Список всех услуг.
     * @type {any[]}
     */
    allServices() {
      const mapper = (position) => ({
        category_name: position.categoryName,
        id: position.serviceId,
        item_type: position.itemType,
        name: position.serviceName,
        price: position.cost,
        vat: position.vat,
      });
      const positions = this.positions.filter(
        (position) => !!position.serviceId,
      ).map(mapper);
      return [...this.services, ...positions];
    },
    /**
     * @description Идентификатор пациента.
     * @type {number}
     */
    patientId() {
      return +this.$route.params.id;
    },
  },
  data() {
    return {
      /**
       * @description Тип скидки.
       * @type {string}
       */
      discountType: DISCOUNT_IN_KOPECK,
      /**
       * @description Услуги клиники.
       * @type {any[]}
       */
      services: [],
      /**
       * @description Ожидание окончания загрузки.
       * @type {boolean}
       */
      isAwaitLoading: false,
      /**
       * @description Ожидание завершения запроса.
       * @type {boolean}
       */
      isAwaitRequest: false,
      /**
       * @description Выбранный сотрудник.
       * @type {?number}
       */
      selectedEmployeeId: null,
      /**
       * @description Комментарий счёта.
       * @type {InvoiceComment}
       */
      invoiceComment: '',
      /**
       * @description Сотрудники.
       * @type {any[]}
       */
      employees: [],
      /**
       * @description Позиции.
       * @type {Position[]}
       */
      positions: [],
    };
  },
  methods: {
    /**
     * @description Привести скидку к копейкам.
     * @param {Position[]} positions
     * @returns {Position[]}
     */
    convertDiscountToKopeck(positions) {
      const convert = (candidate) => candidate.discount.convertToKop(
        candidate.getAmount().toKop(),
      );
      return positions.map(
        (candidate) => (candidate.discount.getType() === this.discountType
          ? candidate
          : candidate.setDiscount(convert(candidate))
        ),
      );
    },
    /**
     * @description Привести скидку к процентам.
     * @param {Position[]} positions
     * @returns {Position[]}
     */
    convertDiscountToPercent(positions) {
      const convert = (candidate) => candidate.discount.convertToPercent(
        candidate.getAmount().toKop(),
      );
      return positions.map(
        (candidate) => (candidate.discount.getType() === this.discountType
          ? candidate
          : candidate.setDiscount(convert(candidate))),
      );
    },
    /**
     * @description Получить данные для выставления счета.
     * @param {number} patientId Идентификатор пациента.
     * @returns {Promise}
     */
    fetchInvoiceables(patientId) {
      return this
        .$invoiceGateway
        .viewCreation(patientId);
    },
    /**
     * @description Обработать изменение позиции.
     * @param {number}   index
     * @param {Position} value
     * @returns {void}
     */
    onChangePosition(index, value) {
      this.positions = this.positions.map(
        (candidate, candidateIndex) => (candidateIndex === index ? value : candidate),
      );
    },
    /**
     * @description Обработать удаление позиции.
     * @param {number} index
     * @returns {void}
     */
    onRemovePosition(index) {
      this.positions = this.positions.filter((_, candidateIndex) => (candidateIndex !== index));
    },
    /**
     * @description Обработать ввод типа скидки.
     * @param {string} value
     * @returns {void}
     */
    onInputDiscountType(value) {
      this.discountType = value;
      if (this.discountType === DISCOUNT_IN_KOPECK) {
        this.positions = this.convertDiscountToKopeck(this.positions);
      } else {
        this.positions = this.convertDiscountToPercent(this.positions);
      }
    },
  },
  mixins: [notifierMixin],
};
